import { SelectionAny } from './internal';
export class SelectionReferenceNumber extends SelectionAny {
    getType() {
        return this.get("TYPE" /* Tag.Type */);
    }
}
//# sourceMappingURL=SelectionReferenceNumber.js.map